module.exports = __webpack_public_path__ + "static/media/Mini Project-SY ETRX 20-21.09f55026.pdf";